import { generateMetricRatioKey } from '@intelligence/v3/utils/metric';
import {
  DATASOURCE_KEY_MAP,
  COMMON_METRIC_KEY_MAP,
  SENSORTOWER_METRIC_KEY_MAP,
  MSCIENCE_METRIC_KEY_MAP,
  GAMALYTIC_METRIC_KEY_MAP,
} from './keyMap';
import { MOBILE_DATA_SOURCES_METRICS_MAPPING } from './mobile';
import { COMBINE_DATA_SOURCES_METRICS_MAPPING } from './combine';

/**
 * mobile平台App Annie数据源指标映射
 */
export const MOBILE_APP_ANNIE_METRIC_MAP = MOBILE_DATA_SOURCES_METRICS_MAPPING[DATASOURCE_KEY_MAP.APP_ANNIE];

/**
 * mobile平台Sensor Tower数据源指标映射
 */
export const MOBILE_SENSORTOWER_METRIC_MAP = MOBILE_DATA_SOURCES_METRICS_MAPPING[DATASOURCE_KEY_MAP.SENSORTOWER];

/**
 * mobile平台OGDB数据源指标映射
 */
export const MOBILE_OGDB_METRIC_MAP = MOBILE_DATA_SOURCES_METRICS_MAPPING[DATASOURCE_KEY_MAP.OGDB];

/**
 * combine平台mscience数据源的指标映射
 */
const COMBINE_MSCIENCE_METRIC_MAP = COMBINE_DATA_SOURCES_METRICS_MAPPING[DATASOURCE_KEY_MAP.MSCIENCE];

/**
 * combine平台gamalytic数据源的指标映射
 */
const COMBINE_GAMALYTIC_METRIC_MAP = COMBINE_DATA_SOURCES_METRICS_MAPPING[DATASOURCE_KEY_MAP.GAMALYTIC];

/**
 * 情报指标映射
 * 键：由平台、数据源、指标三个字符串拼接而成，其中这三个字符串可以是任意的
 */
export const DBI_METRIC_MAP: IRecord = {
  mobile__appannie__au: MOBILE_APP_ANNIE_METRIC_MAP[COMMON_METRIC_KEY_MAP.AU],
  mobile__appannie__revenue: MOBILE_APP_ANNIE_METRIC_MAP[COMMON_METRIC_KEY_MAP.REVENUE],
  mobile__appannie__arpu: MOBILE_APP_ANNIE_METRIC_MAP[COMMON_METRIC_KEY_MAP.ARPU],
  mobile__appannie__download: MOBILE_APP_ANNIE_METRIC_MAP[COMMON_METRIC_KEY_MAP.DOWNLOAD],
  mobile__sensortower__au: MOBILE_SENSORTOWER_METRIC_MAP[COMMON_METRIC_KEY_MAP.AU],
  mobile__sensortower__sensortower__au: MOBILE_SENSORTOWER_METRIC_MAP[COMMON_METRIC_KEY_MAP.AU],
  mobile__sensortower__revenue: MOBILE_SENSORTOWER_METRIC_MAP[COMMON_METRIC_KEY_MAP.REVENUE],
  mobile__sensortower__arpu: MOBILE_SENSORTOWER_METRIC_MAP[COMMON_METRIC_KEY_MAP.ARPU],
  mobile__sensortower__download: MOBILE_SENSORTOWER_METRIC_MAP[COMMON_METRIC_KEY_MAP.DOWNLOAD],
  mobile__sensortower__ss_cross_app_usage: MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__ss_cross_affinity: MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY],
  mobile__sensortower__cross_app_usage: MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__cross_usage: MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__cross_affinity: MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY],
  mobile__sensortower__sensortower__ss_cross_app_usage:
    MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__sensortower__ss_cross_affinity:
    MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY],
  mobile__sensortower__sensortower__cross_app_usage:
    MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__sensortower__cross_usage:
    MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE],
  mobile__sensortower__sensortower__cross_affinity:
    MOBILE_SENSORTOWER_METRIC_MAP[SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY],
  mobile__ogdb__au: MOBILE_OGDB_METRIC_MAP[COMMON_METRIC_KEY_MAP.AU],
  mobile__ogdb__revenue: MOBILE_OGDB_METRIC_MAP[COMMON_METRIC_KEY_MAP.REVENUE],
  mobile__ogdb__arpu: MOBILE_OGDB_METRIC_MAP[COMMON_METRIC_KEY_MAP.ARPU],
  mobile__ogdb__download: MOBILE_OGDB_METRIC_MAP[COMMON_METRIC_KEY_MAP.DOWNLOAD],
  combine__mscience__digitalRevenue: COMBINE_MSCIENCE_METRIC_MAP[MSCIENCE_METRIC_KEY_MAP.DIGITAL_REVENUE],
  combine__mscience__units: COMBINE_MSCIENCE_METRIC_MAP[MSCIENCE_METRIC_KEY_MAP.DIGITAL_UNITS],
  combine__mscience__digitalARPPU: COMBINE_MSCIENCE_METRIC_MAP[MSCIENCE_METRIC_KEY_MAP.DIGITAL_ARPPU],
  combine__mscience__ast: COMBINE_MSCIENCE_METRIC_MAP[MSCIENCE_METRIC_KEY_MAP.DIGITAL_AST],
  combine__gamalytic__est_revenue: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.PREMIUM_REVENUE],
  combine__gamalytic__est_cumulative_revenue: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.CUMULATIVE_REVENUE],
  combine__gamalytic__est_units: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.UNITS],
  combine__gamalytic__est_cumulative_units: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.CUMULATIVE_UNITS],
  combine__gamalytic__pcu: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.PCU],
  combine__gamalytic__acu: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.ACU],
  combine__gamalytic__steamfollowers: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.FOLLOWERS],
  combine__gamalytic__steamreviews: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.REVIEWS],
  combine__gamalytic__est_price: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.PRICE],
  combine__gamalytic__lifetime_weighted_price: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.LIFETIME_WEIGHTED_PRICE],
  combine__gamalytic__players_by_country: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.PLAYERS_BY_COUNTRY],
  combine__gamalytic__wishlists: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.DAILY_WISHLISTS],
  combine__gamalytic__wishlists_total: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.LIFETIME_WISHLISTS],
  combine__gamalytic__playtime: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.AVG_PLAYTIME],
  combine__gamalytic__followers: COMBINE_GAMALYTIC_METRIC_MAP[GAMALYTIC_METRIC_KEY_MAP.TOTAL_FOLLOWERS],
};

/**
 * 生成数据源指标的键
 * @param dataSource 数据源
 * @param metric 指标
 */
export const generateDBIDataSourceMetricKey = (dataSource?: string, metric?: string) => {
  if (!dataSource || !metric) return '';
  return `${dataSource}__${metric}`;
};

/**
 * 生成情报指标映射的键
 * 注意这里的平台、数据源、指标可以是任意字符串，只要这三个任意字符串拼接的字符串在DBI_METRIC_MAP中能取到对应指标就行了
 * @param entityType 平台
 * @param dataSource 数据源
 * @param metric 指标
 */
export const generateDBIMetricMapKey = (entityType: IEntityType, dataSource?: string, metric?: string) => {
  if (!entityType || !dataSource || !metric) return '';
  const dataSourceMetricKey = generateDBIDataSourceMetricKey(dataSource, metric);
  return `${entityType}__${dataSourceMetricKey}`;
};

/**
 * 获取情报系统标准指标
 * @param entityType 平台
 * @param dataSource 数据源
 * @param metric 指标
 * @return 情报系统标准指标
 */
export const getDBIMetric = (entityType: IEntityType, dataSource?: string, metric?: string): IDBIMetric => {
  const dbiMetricKey = generateDBIMetricMapKey(entityType, dataSource, metric);
  return DBI_METRIC_MAP[dbiMetricKey];
};

export const getDBIMetricByDataSourceMetricKey = (
  entityType: IEntityType,
  dataSourceMetricKey?: string,
): IDBIMetric | null => {
  if (!entityType || !dataSourceMetricKey) {
    return null;
  }

  const key = `${entityType}__${dataSourceMetricKey}`;
  return DBI_METRIC_MAP[key];
};

/**
 * 数据源指标键的映射
 */
export const DATASOURCE_METRIC_KEY_MAP = {
  SENSORTOWER__ACTIVE_USERS: generateDBIDataSourceMetricKey(
    DATASOURCE_KEY_MAP.SENSORTOWER,
    SENSORTOWER_METRIC_KEY_MAP.ACTIVE_USERS,
  ),
  SENSORTOWER__CROSS_APP_USAGE: generateDBIDataSourceMetricKey(
    DATASOURCE_KEY_MAP.SENSORTOWER,
    SENSORTOWER_METRIC_KEY_MAP.CROSS_APP_USAGE,
  ),
  SENSORTOWER__CROSS_AFFINITY: generateDBIDataSourceMetricKey(
    DATASOURCE_KEY_MAP.SENSORTOWER,
    SENSORTOWER_METRIC_KEY_MAP.CROSS_AFFINITY,
  ),
};

/**
 * 数据源指标键的映射（环比）
 */
export const DATASOURCE_METRIC_RATIO_KEY_MAP: IRecord<string> = Object.entries(DATASOURCE_METRIC_KEY_MAP).reduce(
  (acc, cur) => {
    const [key, value] = cur || [];
    return { ...acc, [key]: generateMetricRatioKey(value) };
  },
  {},
);
